import { useEffect } from 'react';
import assetPath from '../utils/assetPath';

const DEFAULT_TITLE = 'SΛLTY Airsoft';
const DEFAULT_DESCRIPTION =
  'SΛLTY is a French airsoft team focused on disciplined play, clear communication, and consistent field performance.';
const DEFAULT_IMAGE = assetPath('/assets/logo-salty.png');
const DEFAULT_URL = 'https://salty-squad.fr/';

const setMetaTag = (key, value, attr = 'name') => {
  if (typeof document === 'undefined' || !value) {
    return;
  }
  const selector = attr === 'property' ? `meta[property="${key}"]` : `meta[name="${key}"]`;
  let tag = document.querySelector(selector);

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }

  tag.setAttribute('content', value);
};

const setLinkTag = (rel, href) => {
  if (typeof document === 'undefined' || !href) {
    return;
  }
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const setStructuredData = (data) => {
  if (typeof document === 'undefined' || !data) {
    return;
  }
  let script = document.getElementById('salty-jsonld');
  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'salty-jsonld';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
};

const Seo = ({ title, description, image, url }) => {
  const formattedTitle = title ? `${title} · ${DEFAULT_TITLE}` : DEFAULT_TITLE;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const metaImage = image || DEFAULT_IMAGE;
  const metaUrl = url || DEFAULT_URL;

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = formattedTitle;
    }
  }, [formattedTitle]);

  useEffect(() => {
    setMetaTag('og:type', 'website', 'property');
    setMetaTag('og:site_name', DEFAULT_TITLE, 'property');
    setMetaTag('twitter:card', 'summary_large_image');
  }, []);

  useEffect(() => {
    setMetaTag('description', metaDescription);
    setMetaTag('og:description', metaDescription, 'property');
    setMetaTag('twitter:description', metaDescription);
  }, [metaDescription]);

  useEffect(() => {
    setMetaTag('og:title', formattedTitle, 'property');
    setMetaTag('twitter:title', formattedTitle);
  }, [formattedTitle]);

  useEffect(() => {
    setMetaTag('og:image', metaImage, 'property');
    setMetaTag('twitter:image', metaImage);
  }, [metaImage]);

  useEffect(() => {
    setMetaTag('og:url', metaUrl, 'property');
    setMetaTag('twitter:url', metaUrl);
    setLinkTag('canonical', metaUrl);
  }, [metaUrl]);

  useEffect(() => {
    setStructuredData({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: DEFAULT_TITLE,
      url: metaUrl,
      logo: metaImage,
      sameAs: ['https://www.instagram.com/salty.airsoft/', 'https://discord.gg/ncMBPzqVza'],
      description: metaDescription,
    });
  }, [metaUrl, metaImage, metaDescription]);

  return null;
};

export default Seo;
